export interface ViewerScopedQueryOptions {
  viewerId?: string | null;
  enabled?: boolean;
}

export function withViewerScope<TOptions extends { queryKey: readonly unknown[] }>(
  queryOptions: TOptions,
  viewerId: string | null | undefined,
): TOptions {
  if (viewerId === undefined) return queryOptions;

  return {
    ...queryOptions,
    queryKey: [...queryOptions.queryKey, "viewer", viewerId],
  } as TOptions;
}
